export const getAuthorization = () => {
    let token = localStorage.getItem("app-token");
    return token === null ? { } : { Authorization:  "Bearer " + token }
}

export const getToken = () => {
    let token = localStorage.getItem("app-token");
    return token === null ? { } : { Token: token }
}